import React, { Component } from 'react';
import { connect } from 'react-redux';
import LogoHD from '../../../../assets/utils/images/logo-hd.png';
import { Container, Button } from 'reactstrap';
import { history } from '../../../../utils/service';

function mapStateToProps(state) {
  return {

  };
}

function mapDispatchToProps(dispatch) {
  return {

  };
}

class HeaderSection extends Component {
  render() {
    return (
      <div className='search-page-header pt-2 pb-2'>
        <Container className="d-flex justify-content-between align-items-center">
          <img src={LogoHD} className="img-logo"/>
          <div>
            <Button
              color="info"
              className="rounded-0"
              onClick={() => {history.push("/pages/register-boxed")}}
            >
              Sign Up
            </Button>
            <Button
              className="ml-4 rounded-0"
              color="danger"
              onClick={() => {history.push("/pages/login-boxed")}}
            >
              Log In
            </Button>
          </div>
        </Container>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
)(HeaderSection);